import { ILeasesForPropertyModel, ILeasesForPropertyNumericInputModel } from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';

export const LeasesForPropertyModel = (
  data: Partial<ILeasesForPropertyNumericInputModel>[],
): ILeasesForPropertyModel[] => {
  return data.map((info: Partial<ILeasesForPropertyNumericInputModel>) => {
    return {
      paymentsEncodedLeaseId: info.paymentsEncodedLeaseId || '',
      startDate: formatTimestampToYMDString(info.startDateEpochTimestamp),
      endDate: formatTimestampToYMDString(info.endDateEpochTimestamp),
      baseRent: info.baseRent || 0,
      status: info.status || '',
      leaseTenants: info.leaseTenants || [],
      securityDeposit: info.securityDeposit || 0,
      securityDepositMandates: info.securityDepositMandates || [],
      proratedRent: info.proratedRent || 0,
      otherMic: info.otherMic || [],
      isRentGuaranteeEligible: info.isRentGuaranteeEligible || false,
      warningForSelectedLease: info.warningForSelectedLease || '',
    };
  });
};
